//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import flick from '@/mixins/Flickity.js'
export default {
  mixins: [flick],
  data() {
    return {
      doFlick: true,
      options: {
        wrapAround: false,
        pageDots: false,
      },
    }
  },
  computed: {
    itemsCount() {
      if (this.parceiros) {
        return this.parceiros.length
      }
    },
  },
  props: ['parceiros'],
}
